export const ROUTES = {
    chooseDebitAccount: '/velg-betalingskonto',
    chooseAgreements: '/velg-avtalegiro',
    summary: '/oppsummering',
};
export default ROUTES;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicm91dGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3dpZGdldHMvTW92ZUF2dGFsZUdpcm8vcm91dGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxNQUFNLE1BQU0sR0FBRztJQUNsQixrQkFBa0IsRUFBRSxzQkFBc0I7SUFDMUMsZ0JBQWdCLEVBQUUsa0JBQWtCO0lBQ3BDLE9BQU8sRUFBRSxlQUFlO0NBQzNCLENBQUM7QUFFRixlQUFlLE1BQU0sQ0FBQyJ9